import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { isAdminRole } from "@/auth/shared";
import {
  BulkEditSchedule,
  bulkEditScheduleSearchSchema,
} from "@/components/admin/schedule/bulk-edit";
import { title } from "@/components/base/primitives";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/admin/schedule")({
  validateSearch: zodValidator(bulkEditScheduleSearchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({
    deps: {
      page,
      pageSize,
      name,
      divisions,
      venues,
      genders,
      startDate,
      endDate,
    },
    context: { queryClient, trpc },
  }) => {
    const viewer = await queryClient.ensureQueryData(
      trpc.viewer.get.queryOptions(),
    );

    // Check if user is admin
    if (!viewer || !isAdminRole(viewer.role)) {
      throw redirect({ to: "/not-found" });
    }

    await queryClient.ensureQueryData(
      trpc.tournaments.search.queryOptions({
        page,
        pageSize,
        name,
        divisions,
        venues,
        genders,
        past: false,
        startDate,
        endDate,
      }),
    );
  },
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useSearch();

  return (
    <DefaultLayout classNames={{ content: "" }}>
      <div className="flex flex-col gap-6">
        <div className="px-4 pt-4">
          <h1 className={title({ size: "lg", className: "text-center" })}>
            Schedule
          </h1>
        </div>

        <BulkEditSchedule params={params} />
      </div>
    </DefaultLayout>
  );
}
